module.exports = __webpack_public_path__ + "img/bg_people_home_01.1a8e05fc.png";